/**
 * i18n: PT-BR (padrão) e English.
 * Preferência: localStorage 'pcp_locale' > navegador > fallback pt-BR.
 * Uso nos componentes: const { t } = useTranslation(); return t('common.loading');
 */

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import ptBR from './locales/pt-BR.json';
import en from './locales/en.json';

const STORAGE_KEY = 'pcp_locale';

const resources = {
  'pt-BR': { translation: ptBR },
  en: { translation: en },
};

const detectorOptions = {
  order: ['localStorage', 'navigator'],
  lookupLocalStorage: STORAGE_KEY,
  caches: ['localStorage'],
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pt-BR',
    supportedLngs: ['pt-BR', 'en'],
    detection: detectorOptions,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    // Em desenvolvimento, avisar chaves faltando (não quebrar a UI)
    saveMissing: false,
    missingKeyHandler: import.meta.env?.DEV
      ? (lng, ns, key) => console.warn('[i18n] missing key:', key, 'lng:', lng)
      : undefined,
  });

// Preferir idioma salvo em Configurações (pcp_settings.locale) quando existir
try {
  const raw = localStorage.getItem('pcp_settings');
  if (raw) {
    const s = JSON.parse(raw);
    if (s.locale && (s.locale === 'pt-BR' || s.locale === 'en')) {
      i18n.changeLanguage(s.locale);
    }
  }
} catch (_) {}

export default i18n;

/** Alias para uso fora de componentes (ex.: toasts em serviços). Preferir useTranslation() dentro de React. */
export const t = i18n.t.bind(i18n);
